import { z } from "zod";

import { Codelist } from "@/data/codelists";

export const PayCodeMeasureUnit = z.union([z.literal("HOURLY"), z.literal("DAILY")]);

export type PayCodeMeasureUnit = z.infer<typeof PayCodeMeasureUnit>;

export const PayCodeMeasureUnitCodelist = Codelist<PayCodeMeasureUnit>(PayCodeMeasureUnit);

export type PayCodeMeasureUnitCodelist = z.infer<typeof PayCodeMeasureUnitCodelist>;
